class ActionProvider {
  constructor(createChatBotMessage, setStateFunc, createClientMessage) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createClientMessage = createClientMessage;
  }

  handleGreet = () => {
    const message = this.createChatBotMessage('Hola gracias por ver mi sitio', {
      delay: 300,
    });
    this.addMessageToBotState(message);

    const message2 = this.createChatBotMessage(
      'espero que tengas un gran dia',
      { delay: 700 }
    );
    this.addMessageToBotState(message2);

    const message3 = this.createChatBotMessage('Puedo ayudarte en algo más ?', {
      delay: 1000,
      widget: 'options',
    });
    this.addMessageToBotState(message3);
  };

  handleContact = () => {
    const message1 = this.createChatBotMessage(
      'Muy bien, va a ser un placer trabajar con vos ',
      {
        delay: 300,
      }
    );
    this.addMessageToBotState(message1);
    const message2 = this.createChatBotMessage(
      `Voy a llevarte a la sección de contacto asi me contas más sobre tu propuesta`
    );
    this.addMessageToBotState(message2);
    setTimeout(() => {
      window.location.replace('/contact');
    }, 4000);
  };

  handleShare = () => {
    const message1 = this.createChatBotMessage(
      'Podes hacer click en tu red social favorita para pasarle mi pagina a quien desees',
      { widget: 'share', delay: 200 }
    );
    this.addMessageToBotState(message1);
  };

  handleUnknownQuestion = () => {
    const message = this.createChatBotMessage(
      'Perdon todavia no aprendi a responder eso',
      { delay: 200 }
    );
    this.addMessageToBotState(message);
  };

  handleHowAreYou = () => {
    const message = this.createChatBotMessage(
      'Todo bien gracias por preguntar',
      { delay: 200 }
    );
    this.addMessageToBotState(message);
  };

  handleSecretQuestion = () => {
    const message = this.createChatBotMessage(
      'Eu estou apaixonado por Ane Hellen',
      { delay: 200 }
    );
    this.addMessageToBotState(message);
  };

  addMessageToBotState = messages => {
    if (Array.isArray(messages)) {
      this.setState(state => ({
        ...state,
        messages: [...state.messages, ...messages],
      }));
    } else {
      this.setState(state => ({
        ...state,
        messages: [...state.messages, messages],
      }));
    }
  };
}

export default ActionProvider;
